import script from "./PasswordChangeTab.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordChangeTab.vue?vue&type=script&setup=true&lang=js"

import "./PasswordChangeTab.vue?vue&type=style&index=0&id=ca53f50c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca53f50c"]])

export default __exports__